import { JSX } from "react";

export const BrandingVideoItemSkeleton = (): JSX.Element => {
    return (
        <>
            {Array(3)
                .fill(0)
                .map((_, index) => (
                    <div className="c-branding-video-item skeleton" key={index}>
                        <div className="c-branding-video-item__play-button">
                            <svg
                                width="60"
                                height="60"
                                viewBox="0 0 60 60"
                                fill="none"
                            >
                                <defs>
                                    <mask id="play-button-mask">
                                        <circle
                                            cx="30"
                                            cy="30"
                                            r="30"
                                            fill="white"
                                        />
                                        <polygon
                                            points="22,18 22,42 42,30"
                                            fill="black"
                                        />
                                    </mask>
                                </defs>
                                <circle
                                    cx="30"
                                    cy="30"
                                    r="30"
                                    fill="white"
                                    mask="url(#play-button-mask)"
                                />
                            </svg>
                        </div>
                    </div>
                ))}
        </>
    );
};
